// Iki ayar degeri esit mi — primitive icin ===, array/obje icin JSON tabanli.
// applyChangesToData her render'da JSON.parse(stringify(data)) ile derin kopya
// uretiyor; bu yuzden referans karsilastirmasi (!==) array/objeler icin
// her zaman "degisti" gibi gosterirdi. Bunu engellemek icin kullanilir.
//
// String/number array'ler (MultiSelect log seviyeleri vb.) icin sira-bagimsiz
// karsilastirma yapar — kullanici secimleri farkli sirada yaparsa "degismis"
// olarak isaretlenmez.
export default function valuesEqual(a, b) {
  if (a === b) return true;
  if (a === null || a === undefined || b === null || b === undefined)
    return false;

  // Array karsilastirma
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    const allPrimitive = a.every((v) => v === null || typeof v !== "object");
    const bAllPrimitive = b.every((v) => v === null || typeof v !== "object");
    if (allPrimitive && bAllPrimitive) {
      // Primitive array — set gibi (sira bagimsiz)
      const sa = [...a].sort();
      const sb = [...b].sort();
      for (let i = 0; i < sa.length; i++) if (sa[i] !== sb[i]) return false;
      return true;
    }
    // Obje dizisi (cups vb.) — sira onemli, JSON-tabanli
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch (_) {
      return false;
    }
  }

  if (typeof a !== typeof b) return false;
  if (typeof a === "object") {
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch (_) {
      return false;
    }
  }
  return false;
}
